import { config } from "../../config/config";
import { Observable } from "rxjs";
import { utilService } from "../utils";

/**
 * Api services for calendar component
 */
export const calendarService = {
  getCalendars,
  // getAudiences,
  getCalendarById,
  saveFavorite,
  removeFavorite,
  getFavorites,
};

function getCalendars(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.calendar + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function getCalendarById(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.calendar + data.id, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function saveFavorite(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.favorites, {
      method: "POST",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function removeFavorite(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.favorites + data.id, {
      method: "DELETE",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function getFavorites(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.favorites + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
